import React, { Fragment } from 'react';
import { Row, Col, Table, Badge } from 'reactstrap';


const Information = ({ data, selectedProductData }) => {
    console.log(selectedProductData, 'data product info selectedProductData')
    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Company</th>
                                <td className="text-right pr-5">{selectedProductData.Company?.client_company_name || '-'}</td>
                            </tr>
                            <tr>
                                <th>Product Name</th>
                                <td className="text-right pr-5">{data.title || '-'}</td>
                            </tr>
                            <tr>
                                <th>Type</th>
                                <td className="text-right pr-5">
                                    {data.type && data.type.length > 0
                                        ? data.type.map(item => item.type.title).join(', ')
                                        : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Geographical Cover</th>
                                <td className="text-right pr-5">
                                    {data.geographical_cover && data.geographical_cover.length > 0
                                        ? data.geographical_cover.map(item => item.geographical_cover.name).join(', ')
                                        : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td className="text-right pr-5">
                                    {/* {data.status || '-'} */}
                                    <Badge color={selectedProductData?.is_active === true ? 'success' : 'danger'}>
                                        {/* {data.status || '-'} */}
                                        {selectedProductData?.is_active ? 'Active' : 'Deactive'}
                                    </Badge>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Information;